import { render } from "./HouseholdDetails.vue?vue&type=template&id=7fda4846&scoped=true"
import script from "./HouseholdDetails.vue?vue&type=script&lang=js"
export * from "./HouseholdDetails.vue?vue&type=script&lang=js"

import "./HouseholdDetails.vue?vue&type=style&index=0&id=7fda4846&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fda4846"]])

export default __exports__